import React, { ReactElement } from 'react';
import { Form, Row, Col, Input } from 'antd';

interface CredentialsInputsProps {
    isDetailMode: boolean;
    username: {
        value?: string;
        label?: string;
        name: (string | number)[] | string | number;
    };
    password: {
        value?: string;
        label?: string;
        name: (string | number)[] | string | number;
    };
}

const CredentialsInputs: React.FC<CredentialsInputsProps> = ({
    isDetailMode,
    username,
    password,
}: CredentialsInputsProps): ReactElement => {
    return (
        <>
            <Row gutter={24}>
                <Col lg={{ span: 8, offset: 3 }} md={{ span: 8, offset: 3 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item label={username.label} name={username.name}>
                        {isDetailMode ? <span>{username.value}</span> : <Input title={username.label} />}
                    </Form.Item>
                </Col>
                <Col lg={{ span: 8, offset: 2 }} md={{ span: 8, offset: 2 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item label={password.label} name={password.name}>
                        {isDetailMode ? <span>{password.value}</span> : <Input title={username.label} />}
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default CredentialsInputs;
